<template lang="pug">
UpsertPageWithTabs(
  :title="`${resource.Key ? 'Edit' : 'Create'} resource`"
  :disabled="disabled"
  :showAuditTrail="showAuditTrail"
  objectType="Resource",
  :objectKey="resource.Key"
  :tabNames="tabs"
  :pending="isSaving"
  @save="$emit('save')"
  @cancel="$emit('cancel')"
  )
  template(slot="tab-general")
    ResourceGeneralTab(
      :resource="resource"
      :forEditorModel="forEditorModel"
      ref="resourceGeneralTab"
      :disabled="disabled || isSaving"
      :enableMultilanguage="enableMultilanguage"
      :enableResourceGroups="enableResourceGroups"
      :resources="resources"
      :feedResources="feedResources"
      :resourceTypes="resourceTypes"
      :vuelidate="vuelidate"
      )

  template(slot="tab-segments" v-if="showSegmentsTab")
    ResourceSegmentsTab(v-model="segmentConfiguration" :disabled="disableSecondaryPanels")

  template(slot="tab-advanced" v-if="showAdvancedTab")
    ResourceAdvancedSettingsTab(
      v-if="resourceSettings"
      :settings="resourceSettings"
      :disabled="disableSecondaryPanels"
      )
</template>

<script>
import { mapGetters } from 'vuex'
import UpsertPageWithTabs from '@v/components/UpsertPageWithTabs.vue'
import ResourceGeneralTab from '@v/inventory/resources/edit/tabs/ResourceGeneralTab.vue'
import ResourceAdvancedSettingsTab from '@/vue/inventory/resources/edit/tabs/ResourceAdvancedSettingsTab.vue'
import ResourceSegmentsTab from '@v/inventory/resources/edit/tabs/ResourceSegmentsTab.vue'
import editModelPropValidator from './editModelPropValidator.js'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  name: 'UpsertResource',
  components: {
    UpsertPageWithTabs,
    ResourceGeneralTab,
    ResourceAdvancedSettingsTab,
    ResourceSegmentsTab,
  },
  props: {
    resource: { type: Object, required: true },
    segmentConfiguration: Object, // todo: refactor
    showAuditTrail: Boolean,
    enableMultilanguage: Boolean,
    enableResourceGroups: Boolean,
    disabled: Boolean,
    isSaving: Boolean,
    forEditorModel: {
      type: Object,
      validator: editModelPropValidator,
      required: true,
    },
    vuelidate: { type: Object, required: true },
  },
  data() {
    return {
      culture: null,
    }
  },
  computed: {
    ...mapGetters('briqState', ['userHasPermission']),
    userCanAddViewAdvancedSettings() {
      return this.userHasPermission(Permission.API_Admin_Settings_Read)
    },
    disableSecondaryPanels() {
      return this.disabled || this.resource.isSubResource() || this.isSaving
    },
    resources() {
      return this.forEditorModel.Resources
    },
    feedResources() {
      return this.forEditorModel.FeedResources
    },
    resourceTypes() {
      return this.forEditorModel.ResourceTypes
    },
    resourceSettings() {
      return this.forEditorModel.Settings
    },
    showSegmentsTab() {
      const hasSegments = this.segmentConfiguration && this.segmentConfiguration.segments.length > 0
      return this.forEditorModel.userCanConfigureSegments && hasSegments
    },
    showAdvancedTab() {
      return this.forEditorModel.Settings && this.userCanAddViewAdvancedSettings
    },
    hasMultilanguage() {
      return this.enableMultilanguage && !!this.resource.hasAvailableCultures()
    },

    tabs() {
      const tabNames = ['General']
      if (this.showSegmentsTab) tabNames.push('Segments')
      if (this.showAdvancedTab) tabNames.push('Advanced')
      return tabNames
    },
  },
}
</script>
